import { Theme } from '@mui/material/styles';

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    small: true;
  }
}

export default function Typography(theme: Theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: theme.spacing(1)
        }
      },
      variants: [
        {
          props: { variant: 'small' },
          style: {
            fontSize: '12px'
          }
        }
      ]
    }
  };
}
